import React from 'react'
import EmailIcon from 'Svgs/Inbox'
import WhatsAppIcon from 'Svgs/WhatsAppIcon'
import PageHead from 'Components/PageHead'
import Layout from 'Components/Layout'

const AboutUsPage = () => (
  <div>
    <PageHead title="About Us" />
    <div data-spy="scroll" data-target=".navbar">
      <div>
        <div>
          <div className="m-4 mt-7 mx-4 sm:m-7 md:m-12">
            <h4 className="text-3xl text-center">Who are we?</h4>
          </div>
          <div className="m-4 mt-7 mx-4 sm:m-7 md:m-12">
            <p className="text-xl">
              We are an educational technology startup called&nbsp;
              <b>Ylurn</b>
              &nbsp;(pronounced&nbsp;
              <i>y-learn</i>
              ). Ylurn is on a mission to transform the future of education by
              making quality education accessible to everyone.
            </p>
          </div>
        </div>
        <hr />
        <div>
          <div className="m-4 mt-7 mx-4 sm:m-7 md:m-12">
            <h4 className="text-3xl text-center">Why fix education?</h4>
          </div>
          <div className="m-4 mt-7 mx-4 sm:m-7 md:m-12">
            <p className="text-xl">
              Human brain power is vastly underutilized on this planet because
              most people lack access to a good education. Strong education
              systems lead to greater social mobility, better workers, better
              citizens, and more. A small increase in the learning output of
              education systems across the globe would have an enormous impact
              on human productivity and economic growth. This is why we feel
              education is such an important problem to work on. Read more on
              our&nbsp;
              <a href="https://blog.ylurn.com/about-us/">blog.</a>
            </p>
          </div>
        </div>
        <hr />
        <div
          style={{ textAlign: 'center', marginBottom: '100px' }}
          id="contactus"
        >
          <div className="m-4 mt-7 mx-4 sm:m-7 md:m-12">
            <h4 className="text-3xl text-center">Contact Us</h4>
          </div>
          <p className="text-xl">Email</p>
          <p>
            <a
              href="mailto:contact@ylurn.com"
              rel="noreferrer noopener"
              target="_blank"
              className="cursor-pointer text-blue-700"
            >
              <EmailIcon className="align-middle h-6 text-blue-600" />
              &nbsp;contact@ylurn.com
            </a>
          </p>
          <br />
          <br />
          <p className="text-xl">WhatsApp</p>
          <p>
            <a
              href="https://wa.me/917397272218"
              target="_blank"
              className="cursor-pointer text-blue-700"
              rel="noopener noreferrer"
            >
              Chat on WhatsApp
              <WhatsAppIcon
                style={{
                  verticalAlign: 'middle',
                  margin: '0 5px',
                  height: '30px',
                  width: '30px',
                }}
              />
            </a>
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
)

export default Layout(AboutUsPage, {
  sidebarVariant: 'LANDING',
  isFooterPresent: true,
})
